import { useState, DragEvent, ChangeEvent } from 'react';
import { Typography } from '@/frontend/shared/ui/Typography';
import styles from './DataroomFileContainer.module.scss';
import { DataroomFileUploadIcon } from '@/frontend/shared/assets/icons/DataroomFileUploadIcon';
import { File } from '../File/File';
import clsx from 'clsx';

export function DataroomFileContainer({ name, files, handleFileUpload }: { name: string, files: string[] | undefined, handleFileUpload: (category: string, files: string[]) => void }) {
    const [isDragging, setIsDragging] = useState(false);
    const [dragDepth, setDragDepth] = useState(0);

    function handleDragEnter(e: DragEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
        setDragDepth(prev => prev + 1);
        setIsDragging(true);
    }

    function handleDragOver(e: DragEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
    }

    function handleDragLeave(e: DragEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
        setDragDepth(prev => prev - 1);
        if (dragDepth === 1) {
            setIsDragging(false);
        }
    }

    function handleDrop(e: DragEvent<HTMLDivElement>) {
        e.preventDefault();
        e.stopPropagation();
        setDragDepth(0);
        setIsDragging(false);
        const files = Array.from(e.dataTransfer.files).map(file => file.name);
        handleFileUpload(name, files);
    }

    function handleInputChange(e: ChangeEvent<HTMLInputElement>) {
        const fileNames = Array.from(e.target.files || []).map(file => file.name);
        handleFileUpload(name, fileNames);
    }

    return (
        <div className={clsx(styles.mainContainer, { [styles.hovering]: isDragging })}
            onDragEnter={handleDragEnter}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            onDrop={handleDrop}>
            <div className={styles.title}>
                <Typography variant="label-3" color="greyscale700">
                    {name}
                </Typography>
                <input className={styles.hidden} type="file" id={name} multiple onChange={handleInputChange} />
                <label htmlFor={name} className={styles.UploadLabel}><DataroomFileUploadIcon /></label>
            </div>
            {files && <div className={styles.filesContainer}>
                {files.map(file => <File key={file} name={file} />)}
            </div>}
        </div>
    );
}
